// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {

  production: false,

  firebase: {

    apiKey: "AIzaSyDOyemQmtYWTmRmIs5fNs7uYpBq1w-_Sng",

    authDomain: "organizehome-cb864.firebaseapp.com",

    databaseURL: "https://organizehome-cb864.firebaseio.com",

    projectId: "organizehome-cb864",

    storageBucket: "organizehome-cb864.appspot.com",

    messagingSenderId: "784311028443",

    appId: "1:784311028443:web:a0a0c9c705260dfa16dafe"  }

};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
